<template>
  <v-container fluid class="talent-description-page">
    <transition mode="out-in">
      <div v-if="Talent && Talent._slug === talentSlug && !playerLoading"  key="loaded" class="page-content">
        <seo-v-img v-if="$vuetify.breakpoint.smAndDown" class="hero-image" cover :src="`/media/${Talent.mobilePreview.id}`" :lazy-src="JSON.parse(Talent.mobilePreview.metaData)['image-lazy-src']" height="50vh" width="100vw" />

        <v-row class="px-6 mb-8 mt-md-12 pl-md-32 content-row" :class="{'flex-nowrap': $vuetify.breakpoint.mdAndUp}" align="center">
          <!-- avatar column -->
          <v-col cols="12" md="auto" class="shrink">
            <transition appear name="from-below">
              <v-avatar style="--appear-delay: 100ms;" :size="$vuetify.breakpoint.mdAndUp ? 130 : 90">
                <seo-v-img :src="`/media/${Talent.picture.id}`" :alt="Talent.name" cover :lazy-src="JSON.parse(Talent.picture.metaData)['image-lazy-src']" />
              </v-avatar>
            </transition>
          </v-col>
          <!-- right column -->
          <v-col cols="12" md="8" class="grow ml-4">
            <v-row no-gutters>
              <v-col><CharSplitText style="--appear-delay: 200ms;" tag="h1" :text="Talent.name" /></v-col>
              <!-- <v-col><h1>{{Talent.name}}</h1></v-col> -->
            </v-row>
            <v-row no-gutters>
              <transition appear name="from-below">
                <v-col style="--appear-delay: 300ms;" class="grow"><h2 class="mb-2 text-nationality">{{Talent[`${$language.current}Nationality`]}}</h2></v-col>
              </transition>
            </v-row>
            <v-row no-gutters>
              <transition appear name="from-below">
                <SocialRepeater style="--appear-delay: 400ms;" class="grow ml-n2 mt-1" :data="Talent.social" />
              </transition>
            </v-row>
          </v-col>
        </v-row>
        <component
          class="px-2 pl-md-32 py-4 py-md-5"
          :class="{'ml-md-16': block._repeaterType !== 'Title'}"
          v-for="(block, i) in Talent[`${$language.current}Content`]"
          :key="i"
          :is="repeaterComponents[block._repeaterType]"
          full
          invert-ui
          :data="block"
          :cols="5"
          :style="{'--appear-delay': `${500 + (i  * 100)}ms`}"
          />
          <!-- display-mode="compact" -->
      </div>

      <v-row v-else class="fill-height" align="center" justify="center" key="loading">
        <LoadingSpinner />
      </v-row>
    </transition>

  </v-container>
</template>

<script>
import GetTalentEN from '@/graphql/GetTalent_EN.gql'
import GetTalentIT from '@/graphql/GetTalent_IT.gql'

import ContentImage from '@/atoms/ContentImage'
import ContentParagraph from '@/atoms/ContentParagraph'
import ContentTitle from '@/atoms/ContentTitle'
import ContentVideoYoutubePlayer from '@/atoms/ContentVideoYoutubePlayer'
import ContentGallery2 from '@/atoms/ContentGallery2'
import ContentVideoVimeoPlayer from '@/atoms/ContentVideoVimeoPlayer'
import ContentSocial from '@/atoms/ContentSocial'
// import CloseIcon from '@/assets/img/close.svg'
// import ArrowLeft from '@/assets/img/chevron-left.svg'
import SocialRepeater from '@/molecules/SocialRepeater'
import CharSplitText from '@/atoms/CharSplitText'
import LoadingSpinner from '@/atoms/LoadingSpinner'

export default {
  name: 'TalentDescription',
  components: {
    // CloseIcon,
    // ArrowLeft,
    SocialRepeater,
    CharSplitText,
    LoadingSpinner
  },
  props: {
    playerLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    talentSlug: {
      type: String,
      required: true
    }
  },

  apollo: {
    Talent: {
      query () {
        return this.localizedQueries[this.$language.current].get
      },
      variables () {
        return {
          slug: this.talentSlug,
          status: 'PUBLISHED'
        }
      }
    }
  },

  data () {
    return {
      repeaterComponents: {
        Image: ContentImage,
        Paragraph: ContentParagraph,
        Title: ContentTitle,
        YoutubeVideo: ContentVideoYoutubePlayer,
        VimeoVideo: ContentVideoVimeoPlayer,
        Gallery: ContentGallery2,
        Social: ContentSocial
      },
      localizedQueries: {
        en: {
          get: GetTalentEN
        },
        it: {
          get: GetTalentIT
        }
      }
    }
  },
  metaInfo () {
    return {
      // home page browser title
      title: this.Talent ? this.Talent.name : null,
      meta: [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.Talent ? this.Talent.name : ''} | ${this.$root.siteSettings.siteTitle}` }
      ]
    }
  }
}
</script>

<style scoped lang="scss">

.talent-description-page {
  @include breakpoint('xl-only') {
    padding-top: 86px;
  }
}

.pl-md-32 {
  @include breakpoint('md-and-up') {
    padding-left: 128px !important;
  }
}

h1 {
  color: $c-pink;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
}

// .close-icon {
//   width: 12px;
//   height: 12px;
//   stroke: map-get($shades, 'black');
// }

.close-btn-row {
  @include breakpoint('sm-and-down') {
    position: absolute;
    width: 100%;
    top: calc(50vh - 50px);
  }
}

.content-row {
  @include breakpoint('sm-and-down') {
    padding-top: calc(50vh - 130px);
  }
}

// .talent-description-page {
//   // background-color: map-get($material-light, 'background');
//   // min-height: 100%;
//   @include breakpoint('sm-and-down') {
//     margin-bottom: -224px !important;
//   }

//   .page-content {
//     @include breakpoint('sm-and-down') {
//       margin-top: -224px !important;
//     }
//   }
// }
</style>
